import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultButton, PrimaryButton } from "../../../../Constant";
import { DEFAULT_BUTTONS, DEFAULT_BUTTONS_LIST } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const DefaultButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={DefaultButton} span={DEFAULT_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn color="primary" id="Tooltip-1">{PrimaryButton}</Btn>
        <ToolTip target="Tooltip-1" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-primary</ToolTip>
        {DEFAULT_BUTTONS_LIST.map((data, index) => (
          <CommonButton key={index} item={data} />
        ))}
      </CardBody>
    </Card>
  );
};

export default DefaultButtons;
